export var createQueryParams = function createQueryParams(params) {
  return Object.keys(params).map(function (key) {
    return "".concat(key, "=").concat(params[key]);
  }).join('&');
};